import { render, staticRenderFns } from "./assignee_title.vue?vue&type=template&id=9f0c1516&"
import script from "./assignee_title.vue?vue&type=script&lang=js&"
export * from "./assignee_title.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "assignee_title.vue"
export default component.exports